import { createNamespacedHelpers } from 'vuex';
import BaseStore from '@/store';
import actions from './users.actions.js';
import getters from './users.getters.js';
import mutations from './users.mutations.js';
import state from './users.state.js';

BaseStore.registerModule('users', {
	namespaced: true,
	state,
	actions,
	getters,
	mutations
});
export default BaseStore;

let { mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('users');

export {
	mapState,
	mapGetters,
	mapMutations,
	mapActions
};
